<div class="not-found__404">404</div>
<div class="not-found__message">{{ 'not_found.message' | translate }}</div>
